import * as Yup from 'yup'

const Schema = Yup.object().shape({
  email: Yup.string()
    .email('Email Address must be a valid email')
    .required('Email Address is required'),
  firstName: Yup.string()
    .max(50, 'First Name must not exceed 50 characters')
    .required('First Name is required'),
  lastName: Yup.string()
    .max(50, 'Last Name must not exceed 50 characters')
    .required('Last Name is required'),
})

export default Schema
